/**
 * Azure pipeline config
 */
const AZ_PIPELINE_BRAND = {
    brand: '#{brand}',
    displayName: '#{displayName}',
    appRoot: '#{appRoot}'
}

/**
 * Main settings file for the app
 */

// Pushy config
const pushyAppIdDev = "691b206cb7e2f9df7184b6f3"
const pushyAppIdProd = "";

const defaultTermsDocumentId = "FAA1EE58-4865-4EA2-9CC0-D06452570E0C";

// All current brands
const allBrands = {
    whizzoh: {
        pwaBrandName: "Whizzoh",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "E5D28813-3AAA-4B89-BC12-2B0A3ED53846",
        scheme: {
            schemeId: "Whizzoh",
            clientId: "Whizzoh",
            schemeName: "Whizzoh",
            schemeFriendlyName: "Whizzoh",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    outsurance: {
        pwaBrandName: "OUTsurance",
        showNewsFeed: true,
        serviceDbSurge: "5aab511f-ff83-4269-bb0f-6048d040d006",
        termsDocumentId: '607C1316-4B0E-477A-8748-43F6FD8A37DD',
        darkMode: false
    },
    ignition: {
        pwaBrandName: "SafeBase",
        showNewsFeed: true,
        serviceDbSurge: "B5B206B1-BCBA-4B79-9F9B-E926BB18BF41",
        termsDocumentId: "3C47816B-61B8-4C6E-97C1-5A2CF3A62423",
        darkMode: false
    },
    assistsa: {
        pwaBrandName: "AssistSA",
        whitelabel: false,
        showNewsFeed: true,
        darkMode: true
    },
    budgetinsurance: {
        pwaBrandName: "Budget Insurance",
        whitelabel: false,
        serviceDbSurge: "8EBB7A71-4CCC-4484-AA8B-F52FCCC5E777",
        showNewsFeed: true,
        darkMode: true
    },
    olab: {
        pwaBrandName: "Associated Brokers",
        whitelabel: false,
        serviceDbSurge: "4366CC62-6417-42F4-B566-9E9BFEE0A9F7",
        showNewsFeed: true,
        darkMode: true
    },
    tsag: {
        pwaBrandName: "Auto & General",
        whitelabel: false,
        serviceDbSurge: "4E22833A-7F62-42DF-9CAD-C6FB54C57ADD",
        showNewsFeed: true,
        darkMode: true
    },
    tsffw: {
        pwaBrandName: "First For Women",
        whitelabel: false,
        serviceDbSurge: "C63BC5E0-42F5-451E-9553-E37D41A5174B",
        darkMode: true
    },
    tsvs: {
        pwaBrandName: "Virseker",
        whitelabel: false,
        serviceDbSurge: "BDAD622A-5E57-4211-9E68-FBEF9CB7E8AC",
        showNewsFeed: true,
        darkMode: true
    },
    tsdd: {
        pwaBrandName: "Dial Direct",
        whitelabel: false,
        serviceDbSurge: "1722D04D-BBD7-4B46-9076-F1103606BB41",
        showNewsFeed: true,
        darkMode: true
    },
    nedbank: {
        pwaBrandName: "Nedbank",
        whitelabel: false,
        serviceDbSurge: "6A30B892-FA09-463C-8898-0A18D51BAEFD",
        showNewsFeed: true,
        darkMode: true
    },
    /**
     * Leroy Merlin
     */
    lmgreenstone: {
        pwaBrandName: "Leroy Merlin - Greenstone",
        whitelabel: false,
        serviceDbSurge: "",
        showNewsFeed: true,
        scheme: {
            schemeId: "001",
            clientId: "LM",
            schemeName: "Greenstone",
            schemeFriendlyName: "Greenstone",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    lmlittlefalls: {
        pwaBrandName: "Leroy Merlin - Little Falls",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "",
        scheme: {
            schemeId: "002",
            clientId: "LM",
            schemeName: "LittleFalls",
            schemeFriendlyName: "Little Falls",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    lmboksburg: {
        pwaBrandName: "Leroy Merlin - Boksburg",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "",
        scheme: {
            schemeId: "003",
            clientId: "LM",
            schemeName: "Boksburg",
            schemeFriendlyName: "Boksburg",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    lmfourways: {
        pwaBrandName: "Leroy Merlin - Fourways",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "",
        scheme: {
            schemeId: "004",
            clientId: "LM",
            schemeName: "Fourways",
            schemeFriendlyName: "Fourways",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    lmcenturion: {
        pwaBrandName: "Leroy Merlin - Centurion",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "",
        scheme: {
            schemeId: "005",
            clientId: "LM",
            schemeName: "Centurion",
            schemeFriendlyName: "Centurion",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    /**
     * Enabled on 30 Oct 2025
     */
    lmonline: {
        pwaBrandName: "LMonline",
        whitelabel: false,
        showNewsFeed: true,
        serviceDbSurge: "",
        scheme: {
            schemeId: "006",
            clientId: "LM",
            schemeName: "LMOnline",
            schemeFriendlyName: "LMOnline",
            callCenterNumber: "xxx"
        },
        darkMode: true
    },
    /**
     * Standard Bank Looksee
     * 
     * added 18 Dec 2024 
     */
    looksee: {
        pwaBrandName: "Looksee",
        whitelabel: false,
        showNewsFeed: true,
        darkMode: false
    },
    /**
     * Find a Maker (Allan Gray)
     * 
     * added 2 July 2025 
     */
    fam: {
        pwaBrandName: "Find a Maker",
        whitelabel: true,
        showNewsFeed: false,
        darkMode: true
    },

    /**
     * Brand disabled at 15-07-2024
     */
    // lmstore: {
    //     pwaBrandName: "LMstore",
    //     whitelabel: false,
    //     serviceDbSurge: ""
    // },
    /**
     * Brand disabled at 15-07-2024
     */
    // Brand disabled at 07-07-2023
    // ami: {
    //     pwaBrandName: "#AskAmi",
    //     serviceDbSurge: "D849C004-892D-4CD4-817F-1E51592F6E87"
    // },
    // Brand disabled at 07-07-2023
    // mycomplex: {
    //     pwaBrandName: "MyComplex",
    //     serviceDbSurge: "E131DA49-6FAB-478C-A84F-94D681312169"
    // },
};

/**
 * Edit below values
 */
// Control branding 
const pwaBrand = !AZ_PIPELINE_BRAND.brand.includes('#{') ? AZ_PIPELINE_BRAND.brand : 'looksee';  
// Environment 
const pwaDomain = 'https://prodza.whizzoh.co.za/';
// App base URL
const pwaRoot = pwaDomain + 'InteractiveWebsite/' + ( !AZ_PIPELINE_BRAND.appRoot.includes('#{') ? AZ_PIPELINE_BRAND.appRoot : 'StandardBank/LookSee/');
// App type  
const pwaType = 'End User';
// PWA description
const pwaDescription = 'Help is always at your fingertips';
/**
 * END 
 */

// Get active brand
const activeBrand = getBrand(pwaBrand, allBrands);
if (!activeBrand)
{
    const errorMsg = `App brand config failed, no brand named '${pwaBrand}' found`;
    throw new Error(errorMsg);
}

// Dark mode
let darkMode = false
if (activeBrand && typeof activeBrand.darkMode != "undefined")
{
    darkMode = activeBrand.darkMode == true
}

// Toggle news feed
const showNewsFeed = activeBrand.showNewsFeed; 

// Branding display name
const pwaBrandName = activeBrand.pwaBrandName;
const pwaBrandNameCaps = pwaBrandName.charAt(0).toUpperCase() + pwaBrandName.slice(1);
const defaultScheme = {
    schemeId: 0,
    clientId: 0,
    schemeName: pwaBrand,
    schemeFriendlyName: pwaBrandName
};

// Terms & Conditions DocumentId
const termsDocumentId = typeof activeBrand.termsDocumentId !== "undefined" ? activeBrand.termsDocumentId : defaultTermsDocumentId;

const offCanvasTemplates = {
    // Off-canvas elements
    globalMenus: 'menus/menus.ejs',
    jobMenus: 'menus/job-menus.ejs',
    paymentMenu: 'menus/payment-menus.ejs',
    paymentFrame: 'menus/payment-frame.ejs',
    bankCardMenus: 'menus/bankcard-menus.ejs',
    bidMenus: 'menus/bids-menus.ejs',
    quoteMenus: 'menus/quote-menus.ejs',
    chatMenus: 'menus/chat-menus.ejs',
    jobRatingMenus: 'menus/rating-menus.ejs',
    voucherMenus: 'menus/voucher-menus.ejs',
    inboxMenus: 'menus/inbox-menus.ejs',
    endUserAddressMenus: 'menus/enduser-address-menus.ejs',
    personalDetailMenus: 'menus/personal-details-menus.ejs',
    unsignedDocs: 'menus/unsigned-doc-menus.ejs',
    invoiceMenus: 'menus/invoice-menus.ejs',
    termsConditions: 'menus/terms-conditions.ejs',
    assessmentMenus: 'menus/assessment-type-menus.ejs',
    // Notification templates
    notifications: 'notifications/notifications.ejs',
    // Nav bar
    menu: 'nav/navigation.ejs',
};
   
// Whizzoh is the default CSS 
let styleSource = pwaRoot + 'styles/highlights/highlight_whizzoh.css';
const brandName = pwaBrand.toLowerCase();

// Only add custom CSS to brands with white-labeling enabled
if (typeof activeBrand.whitelabel === "undefined" || ( typeof activeBrand.whitelabel !== "undefined" && activeBrand.whitelabel === true) )
{
    let clientFolder = brandName;
    switch(brandName)
    {
        // Outsurance
        case 'outsurance':
            clientFolder = 'outsuranceV2';
            break;
    }

    if (clientFolder == "fam")
    {
        clientFolder = "allangray";
    }

    let cacheBuster = Date.now()
    styleSource = pwaDomain + 'client/' + clientFolder + '/style.css?v='+cacheBuster;

    
}

// Default color schemes
const colorSchemes = {
    whizzoh: {
        primary: '#e96550',
        secondary: '#e96550'
    }
};

// Get current brand's color scheme
let brandColorScheme = {};
const currentScheme = colorSchemes[brandName];
if (currentScheme)
{
    brandColorScheme = currentScheme;
}

// White labeling
let whitelabel = true;
if (activeBrand.whitelabel !== "undefined")
{
    whitelabel = activeBrand.whitelabel;
}

let startUrl = (typeof activeBrand.scheme !== "undefined" && typeof activeBrand.scheme.startUrl !== "undefined" && activeBrand.scheme.startUrl != "") ? pwaRoot+activeBrand.scheme.startUrl : pwaRoot;
let pwaAppName = pwaBrand;
if (pwaBrand == "ignition")
{
    pwaAppName = "SafeBase";
}

const settings = {
    // App settings
    domain: pwaDomain,
    appRoot: pwaRoot,
    pwaStartUrl: startUrl,
    builtAt: +new Date(),
    isPWA: true,                // Switch PWA functionality on/off
    isAJAX: true,               // Used for Swup JS transitions (SPA-like app)
    pwaRemind: 1,               // Number of days when to remind user to install PWA
    pwaNoCache: true,           // Will clear cache on each visit if true
    darkMode: darkMode,         // Turn dark mode feature on/off
    showNewsFeed: showNewsFeed, // Turn news feed on dashboard on/off
    // Auth settings
    rememberMe: 90,             // How long to remember user in days
    // Theme settings
    colorScheme: brandColorScheme,
    // Whether app is white labelled or not
    whitelabel: whitelabel,
    // PWA settings
    pwaScope: pwaRoot,
    pwaBrand: pwaBrand,
    pwaScheme: (typeof activeBrand.scheme !== "undefined") ? activeBrand.scheme : defaultScheme,
    pwaBrandName: pwaBrandName,
    pwaBrandStylesheet: styleSource,
    pwaName: pwaAppName + ' ' + pwaType,
    pwaBrandType: pwaType,
    pwaDescription: pwaDescription,
    // Push Notifications
    pushNotifications: {
        appId: (pwaDomain.includes("prodza.whizzoh.co.za")) ? pushyAppIdProd : pushyAppIdDev
    },
    // Services
    services: {
        dbSurge: activeBrand.serviceDbSurge
    },
    // Terms Document ID
    termsDocumentId: termsDocumentId,
    // SwupJS
    swupLinkSelector: 'a[href]:not([href^="tel:"]):not([href="#"]):not([class^="fc-"]):not(.external-link):not(.default-link):not([href^="https"]):not([href^="http"]):not([data-gallery])',
    // App templates
    templates: {
        // Views
        views: {
            index: {
                template: 'views/home.html',
                offCanvas: [
                    offCanvasTemplates.termsConditions
                ],
                filename: 'index.html',
                title: `${pwaBrandNameCaps} - ${pwaDescription}`,
            },
            about: {
                template: 'views/about.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.termsConditions
                ],
                title: 'About - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            dashboard: {
                template: 'views/dashboard.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Home - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            jobs: {
                template: 'views/jobs.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Jobs - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            job: {
                template: 'views/job.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'jobs.html',
                offCanvas: [
                    offCanvasTemplates.bidMenus,
                    offCanvasTemplates.paymentFrame,
                    offCanvasTemplates.paymentMenu,
                    offCanvasTemplates.quoteMenus,
                    offCanvasTemplates.chatMenus,
                    offCanvasTemplates.jobRatingMenus,
                    offCanvasTemplates.termsConditions,
                    offCanvasTemplates.invoiceMenus,
                    offCanvasTemplates.voucherMenus
                ],
                title: 'Job - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            jobCancel: {
                template: 'views/job-cancel.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'job.html',
                offCanvas: [
                    offCanvasTemplates.jobMenus,
                    offCanvasTemplates.termsConditions,
                    offCanvasTemplates.jobRatingMenus,
                ],
                title: 'Cancel job - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            jobNew: {
                template: 'views/job-new.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'jobs.html',
                offCanvas: [
                    offCanvasTemplates.jobMenus,
                    offCanvasTemplates.assessmentMenus,
                ],
                title: 'Create a new job - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            address: {
                template: 'views/address-list.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Addresses - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            addressEdit: {
                template: 'views/address-edit.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'address-list.html',
                offCanvas: [
                    offCanvasTemplates.endUserAddressMenus
                ],
                title: 'Job - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            addressNew: {
                template: 'views/address-new.html',
                navigation: 'nav/header-back.ejs',
                navigationUrl: 'address-list.html',
                offCanvas: [
                    offCanvasTemplates.endUserAddressMenus
                ],
                title: 'Add a new address - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            support: {
                template: 'views/support.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Support - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            inbox: {
                template: 'views/inbox.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.inboxMenus,
                    offCanvasTemplates.invoiceMenus
                ],
                title: 'Inbox - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            personalDetails: {
                template: 'views/personal-details.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.termsConditions
                ],
                title: 'Personal details - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            manageCards: {
                template: 'views/manage-cards.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [
                    offCanvasTemplates.bankCardMenus
                ],
                title: 'Manage cards - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            password: {
                template: 'views/password.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Change your password - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            // Dev page
            images: {
                template: 'views/images.html',
                navigation: 'nav/header-nav.ejs',
                offCanvas: [],
                title: 'Service Images - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            // Chat page for iframe (Nanny)
            chat: {
                template: 'views/chat.html',
                offCanvas: [],
                title: 'Chat - ' + pwaBrandNameCaps,
                mainMenu: offCanvasTemplates.menu
            },
            termsConditions: {
                template: 'views/terms-conditions.html',
                offCanvas: [],
                title: 'Terms and conditions - ' + pwaBrandNameCaps
            },
            invoice: {
                template: 'views/invoice.html',
                offCanvas: [],
                title: 'Invoice - ' + pwaBrandNameCaps
            },
        },
        globalComponents: {
            offCanvas: [
                offCanvasTemplates.globalMenus,
                offCanvasTemplates.notifications,
                offCanvasTemplates.unsignedDocs
            ] 
        }
    },

    // Dependancies
    dependancies: {
        mapbox: [
            'job-new',
            'address-new',
            'address-edit'
        ],
        pica: [
            'job-new'
        ],
        firebase: [
            'job'
        ],
        glightbox: [
            'job'
        ],
    }
}

// Make settings read-only
for( let key in settings)
{
    Object.defineProperty(settings, key, {
        value: settings[key], 
        writable: false
    });
};

function getBrand(pwaBrand, allBrands)
{
    let brandName = pwaBrand.toLowerCase();
    if ( typeof allBrands[brandName] == "undefined" )
    {
        return null;
    }
    return allBrands[brandName];
}
 
module.exports = {
    settings
};